module.exports = __webpack_public_path__ + "static/favicon/favicon-32x32.png";